import React from 'react';
import { Icon } from './Icon.js';
export const IconGridLayout9Fill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "M4.5 12H2.75C1.7835 12 1 11.2165 1 10.25V1.75C1 0.783502 1.7835 0 2.75 0H4.5V12Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("path", { d: "M9.25 0C10.2165 0 11 0.783502 11 1.75V3H6V0H9.25Z", fill: "currentColor" }),
        React.createElement("path", { d: "M11 4.5V7.5H6V4.5H11Z", fill: "currentColor" }),
        React.createElement("path", { d: "M11 9V10.25C11 11.2165 10.2165 12 9.25 12H6V9H11Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconGridLayout9Fill12.js.map